module.exports = __webpack_public_path__ + "static/media/jin_activef5d3d3602d197fd0140459e6e01b1028.webp";